<template>
    <div id="TermsAndConditions" class="p-5">

        <div class="text-center">
            <h1>Términos y condiciones</h1>
        </div>

        <hr>

        <div class="TermsAndConditions-content limit-width mt-4">
            <p>
                Al utilizar el servicio Clave Verde proporcionado por Blackfon, usted acepta cumplir con los siguientes términos y condiciones:
            </p>
            <ul>
                <li>El servicio es gratuito y está destinado exclusivamente para uso educativo por parte de estudiantes de preparatoria y universidad.</li>
                <li>El usuario es responsable de mantener la confidencialidad de su información de acceso y de todas las actividades que ocurran bajo su cuenta.</li>
                <li>El uso del servicio debe cumplir con todas las leyes y regulaciones aplicables. Está prohibido utilizar el servicio para actividades ilegales o no autorizadas.</li>
                <li>Blackfon se reserva el derecho de suspender o cancelar el acceso al servicio en caso de violación de estos términos y condiciones.</li>
                <li>El usuario acepta que Blackfon no será responsable por cualquier daño o pérdida resultante del uso o la imposibilidad de usar el servicio.</li>
                <li>Estos términos y condiciones pueden ser actualizados periódicamente. El uso continuado del servicio constituye la aceptación de cualquier cambio.</li>
            </ul>
            <p>
                Si tiene alguna pregunta o inquietud sobre estos términos y condiciones, por favor contacte a nuestro equipo de soporte.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TermsAndConditions',
};
</script>
